<template>
  <div class='opc-cart__current'>
    <template v-for='item in modifier(billingCycleList)'>
      <div v-if='item.amount' :key='item.billingCycle'>
        <h3 class='opc-cart__current__title'>
          {{ item.label }}
          <div class='opc-cart__current__value text-no-capitalize'>
            {{ $money(item.amount) }}
          </div>
        </h3>
        <h3 class='opc-cart__current__text first-capitalize'>{{ $t('billing.order_summary.extra_charges') }}</h3>
        <h3 class='opc-cart__current__text first-capitalize'>{{ item.renewDate }}</h3>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';
import { BILLING_CYCLE } from '@/common/constants';
import { dateformat } from './next.vue';

export default {
  props: {
    modifier: {
      type: Function,
      default: (x) => x,
    }
  },
  methods: {
    renewDate(cycle) {
      const plans = this.getSelectedPlans.filter((x) => x.billing_cycle == cycle);
      const plan = plans[0];
      if (!plan) return;
      const subscription = this.subscriptionMap[plan.plan_code];
      if (!subscription) return;
      return this.nextDate(subscription?.startTime ?? subscription.planStartTime, subscription?.billingCycle);
    },
    nextDate(startTime, month) {
      const time = moment(startTime).add(month, 'month').format(dateformat);
      return this.isZuoraOutage ? this.$t('billing.zuoraoutage.expire_date', [time]): `${this.$t('billing.order_summary.next_charge_date')} ${time}`;
    },
  },
  computed: {
    ...mapGetters(['nextBillAmount', 'getSelectedPlans', 'subscriptions', 'isZuoraOutage']),
    subscriptionMap() {
      return this.subscriptions.reduce((acc, x) => {
        acc[x.plan_code] = x;
        return acc;
      }, {});
    },
    billingCycleList() {
      return [
        {
          billingCycle: BILLING_CYCLE.MONTHLY,
          amount: this.nextBillAmount?.monthlyCharge,
          label: this.$t('billing.order_summary.total_billed_monthly_current'),
          renewDate: this.renewDate(BILLING_CYCLE.MONTHLY),
        },
        {
          billingCycle: BILLING_CYCLE.QUARTERLY,
          amount: this.nextBillAmount?.quarterlyCharge,
          label: this.$t('billing.order_summary.total_billed_quarterly_current'),
          renewDate: this.renewDate(BILLING_CYCLE.QUARTERLY),
        },
        {
          billingCycle: BILLING_CYCLE.ANNUAL,
          amount: this.nextBillAmount?.annualCharge,
          label: this.$t('billing.order_summary.total_billed_annually_current'),
          renewDate: this.renewDate(BILLING_CYCLE.ANNUAL),
        },
        {
          billingCycle: BILLING_CYCLE.TWO_YEARS,
          amount: this.nextBillAmount?.twoYearsCharge,
          label: this.$t('billing.order_summary.total_billed_two_years_current'),
          renewDate: this.renewDate(BILLING_CYCLE.TWO_YEARS),
        },
        {
          billingCycle: BILLING_CYCLE.THREE_YEARS,
          amount: this.nextBillAmount?.threeYearsCharge,
          label: this.$t('billing.order_summary.total_billed_three_years_current'),
          renewDate: this.renewDate(BILLING_CYCLE.THREE_YEARS),
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-cart__current {
  &__title {
    display: flex;
    text-align: left;
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #00053d;
    text-transform: capitalize;
    @include media(mobile, tablet) {
      font-size: 14px;
      line-height: 1.5;
    }
  }
  &__value {
    margin-left: auto;
    text-align: right;
    font-weight: 450;
    @include media(mobile, tablet) {
      white-space: nowrap;
      font-size: 14px;
      line-height: 1.5;
      font-weight: 400;
    }
  }
  &__text {
    flex: auto;
    font-weight: 500;
    font-size: 14px;
    line-height: 22px;
    color: #515079;
    @include media(mobile, tablet) {
      line-height: 1.5;
      font-weight: 400;
    }
  }
}
</style>

<style lang="scss">
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-cart__total {
  .opc-cart__current__title,
  .opc-cart__current__value {
    font-size: 18px;
    font-weight: 700;
    @include media(mobile, tablet) {
      font-size: 16px;
      line-height: 1.5;
    }
  }
}
</style>
